import * as Yup from 'yup';
import moment from 'moment';

export const editPolicyEndorsementSchema = Yup.object().shape({
    namedInsured: Yup.string().required('Required'),
    address1: Yup.string().required('Required'),
    address2: Yup.string(),
    city: Yup.string().required('Required'),
    zip: Yup.string()
        .transform((value) => value?.replace(/\s/g, ''))
        .min(5, 'Must be a valid 5 digit zip code')
        .max(5, 'Must be a valid 5 digit zip code')
        .required('Required'),
    state: Yup.string().required('Required'),
});

export const addAdjustmentSchema = Yup.object().shape({
    effectiveDate: Yup.string().min(10, 'Must be a valid date').max(10, 'Must be a valid date').required('Required'),
    narrative: Yup.string().required('Required'),
});

export const cancelPolicySchema = Yup.object().shape({
    effectiveDate: Yup.string().min(10, 'Must be a valid date').max(10, 'Must be a valid date').required('Required'),
    narrative: Yup.string().required('Required'),
    productLineCodes: Yup.array().min(1, 'Must select at least one type').of(Yup.string()).required('Required'),
});

export const extendPolicySchema = Yup.object().shape({
    extensionDays: Yup.number().required('Required'),
    narrative: Yup.string().required('Required'),
    productLineCodes: Yup.array().min(1, 'Must select at least one type').of(Yup.string()).required('Required'),
});

export const extendPolicyWithDateSchema = (expirationDate: string) =>
    Yup.object().shape({
        extensionDate: Yup.mixed()
            .required('Required')
            .test('is-valid-date', 'Must be a valid date', (value) => {
                return value && moment.isMoment(value) && (value as any).isValid();
            })
            .test('is-after-expiration', 'Date must be after current expiration date', (value) => {
                if (!value || !moment.isMoment(value)) return false;
                return (value as any).isAfter(moment(expirationDate, 'MM/DD/YYYY'), 'day');
            }),
        narrative: Yup.string().required('Required'),
        productLineCodes: Yup.array().min(1, 'Must select at least one type').of(Yup.string()).required('Required'),
    });
